import { ApiError, ApiResponse } from "src/models";
import { showSnackbar } from "src/store/reducers/navigation/navigationSlice";
import { AppDispatch } from "src/store/rootStore";

const asText = (message: string | string[] | undefined, fallback: string) =>
  Array.isArray(message) ? message.join(", ") : message || fallback;

export const handleApiError = (dispatch: AppDispatch, error: unknown) => {
  const typed = error as ApiError;
  dispatch(
    showSnackbar({
      open: true,
      message: asText(typed?.data?.message, "Something went wrong"),
      type: "error",
    }),
  );
};

export const handleApiResponse = (
  dispatch: AppDispatch,
  response: ApiResponse<unknown>,
) => {
  dispatch(
    showSnackbar({
      open: true,
      message: asText(response?.message, "Saved"),
      type: "success",
    }),
  );
};
